import { Field } from '@datx/core';
import { JsonApiModel } from '../core/jsonApi/jsonApiModel';
import { LearningSectionJsonModel } from '../learning-section/learning-section.json.model';
import { MediaType } from '../core/types';

export class Preview extends JsonApiModel {
  @Field()
  public id!: string;

  @Field()
  public mediaType!: MediaType;

  @Field()
  public name!: string;

  @Field()
  public media_url!: string;
}

export class LearningUnitJsonModel extends JsonApiModel {
  public static override readonly type = 'learning-units';

  @Field({ isIdentifier: true })
  public id!: string;

  @Field()
  public title!: string;

  @Field()
  public subtitle!: string;

  @Field()
  public preview!: Preview | null;

  @Field()
  public lesson_section!: string;

  @Field()
  public processing_time!: number;

  @Field()
  public status!: string;

  @Field()
  public federal_state!: string[];

  @Field()
  public learning_unit_goal!: string;

  @Field({ toMany: () => LearningSectionJsonModel })
  public learningSections!: LearningSectionJsonModel[];

  @Field()
  public learning_unit_type!: string;

  @Field()
  public description!: string;

  @Field()
  public moduleIds!: string[];

  @Field()
  public version!: number;

  @Field()
  public changed_by!: string;
}
